export const getDefaults = (configuration) => {
    const { consumable, options, unlinkedOptions, hasImage, hasDescription, sellable, hasVariations, hasHours, hasPos, hasPresentation, lists, } = configuration;
    const standardDefaults = [
        {
            defaults: { image: null },
            test: hasImage,
        },
        {
            defaults: {
                amount: 0,
                tax: null,
                metadata: { quantitySold: 0, totalRevenue: 0 },
            },
            test: sellable,
        },
        {
            defaults: { description: '' },
            test: hasDescription,
        },
        {
            defaults: { variationGroups: [] },
            test: hasVariations,
        },
        {
            default: { pos: null },
            test: hasPos,
        },
        {
            defaults: { presentation: null },
            test: hasPresentation,
        },
        {
            defaults: {
                hours: [
                    'sunday',
                    'monday',
                    'tuesday',
                    'wednesday',
                    'thursday',
                    'friday',
                    'saturday',
                ].reduce((acc, day) => Object.assign(acc, { [day]: { hours: [], open: true } }), {}),
            },
            test: hasHours,
        },
        {
            defaults: {
                allergens: [],
                glutenFree: false,
                vegetarian: false,
                alcohol: false,
                taxable: true,
            },
            test: consumable,
        },
    ].reduce((acc, { test, defaults }) => (test ? Object.assign(acc, defaults) : acc), {});
    const defaultListsParams = {};
    const listDefaults = lists.reduce((acc, { name }) => ({ ...acc, [name]: [] }), defaultListsParams);
    return {
        available: true,
        availableAt: null,
        brandLevelId: null,
        displayName: '',
        name: '',
        ...listDefaults,
        ...options,
        ...unlinkedOptions,
        ...standardDefaults,
    };
};
//# sourceMappingURL=params.js.map